import React from "react";
import { cx } from "../../../style";
import "./PageHeader.css";

/**
 * PageHeader — единая шапка раздела.
 *
 * @param {React.ReactNode} title       Заголовок.
 * @param {React.ReactNode} [subtitle]  Подпись под заголовком.
 * @param {React.ReactNode} [actions]   Кнопки/контролы справа (напр. <Button>Добавить</Button>).
 * @param {string} [className] @param {object} [style]
 */
export default function PageHeader({ title, subtitle, actions, className, style }) {
  return (
    <div className={cx("ui-page-header", className)} style={style}>
      <div className="ui-page-header__titles">
        <h1 className="ui-page-header__title">{title}</h1>
        {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ui-page-header__actions">{actions}</div>}
    </div>
  );
}
